export const BREAD_CRUMB_MAPPING: { [x: string]: any } = {
    'product-management': {
        'product-management': 'Product ID',
        'add': 'Add New Product ID',
        'add-options': 'Manage Options',
        'update': 'Update Product'
    },
}